import axios from 'axios';

const get = () => axios.get('/fornecedor/default');

export default {
  get,
};
